import {
    Grid,
    TableBody,
    TableContainer,
    TableRow,
    Table,
    TableHead,
    Checkbox,
    withStyles,
    TableCell,
    Tooltip,
    Chip,
    CircularProgress,
    TextField,
    FormControlLabel,
    Box,
    Paper,
    Button,
    Badge,
    InputLabel
} from '@material-ui/core';
import React, { useEffect, useState, useContext, useRef } from 'react';
import AppContext from '../../../../App/AppContext';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal.jsx';
import DialogComp from '../../../../Core/Modal/dialogModal.js';
import formatters from '../../../../Core/Grid/inputFormatter';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { SecondaryButton } from '../../../../Core/FormInput/AppButton';
import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';
import { TextBox } from '../../../../Core/FormInput/index.jsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { debounce } from 'lodash';
import {
    getMAMappingCategory_SearchAccounts,
    getMAMappingCategory_Accounts,
    postMAMappingCategory_AddNominalAccount,
    postMAMappingCategory_DeleteNominalAccount,
    postMAMappingCategory_SwitchReverseSign
} from '../../../../Core/Service/ManageAccount/mappingCategoryModal-service.js';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Clear } from '@material-ui/icons';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
        fontWeight: 500,
        display: 'block',
        minWidth: '150px'
    }
}))(Tooltip);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 16,
        padding: '2px 8px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '2px 8px'
    }
}))(TableCell);
const StyledTableRow = withStyles((theme) => ({
    root: {
        height: '40px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const CustomAutocomplete = withStyles({
    option: {
        padding: '4px 8px',
        minHeight: '30px'
    }
})(Autocomplete);

const TitleComponent = ({ selectedRowData, handleReverseSign }) => (
    <Grid container justifyContent="space-between">
        <Grid item xs={12} sm={6} md={8}>
            <span className="font-semibold">Account Mapped</span>
            <span className="text-gray-600">
                ({selectedRowData.maMappingCategoryID} - {selectedRowData.maMappingCategoryName || ''})
            </span>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={4} container spacing={2} justifyContent="flex-end">
            <Grid item xs={12} sm={6} md={6}>
                <SecondaryButton fullWidth onClick={() => handleReverseSign(true)}>
                    Set Reverse
                </SecondaryButton>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <SecondaryButton fullWidth onClick={() => handleReverseSign(false)}>
                    Reset Reverse
                </SecondaryButton>
            </Grid>
        </Grid>
    </Grid>
);

const CustomPaper = ({ setOpen, ...props }) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Paper
                    // ref={listboxRef}
                    elevation={100}
                    {...props}
                    style={{}}
                />
            </Grid>
            <Grid item xs={12} style={{ backgroundColor: '#0e2132' }} alignItems="center" justifyContent="end">
                {/* <Grid
                        item

                        // style={{ backgroundColor: '#0e2132', textAlign: 'right', padding: '5px', marginTop: '-20px' }}
                    >
                        <Button
                            onClick={() => setState((prev) => ({ ...prev, selectedAccounts: [] }))}
                            style={{ backgroundColor: 'white', color: 'black', height: 25 }}
                        >
                            Clear
                        </Button>
                    </Grid> */}
                <Grid container justifyContent="flex-end" alignItems="center">
                    <Grid
                        onClick={() => setOpen(false)}
                        item
                        style={{ height: 30, width: '100%', backgroundColor: '#0e2132', padding: '3px' }}
                        // style={{ backgroundColor: '#0e2132', textAlign: 'right', padding: '5px', marginTop: '-20px' }}
                    >
                        <Button style={{ backgroundColor: 'white', color: 'black', height: 25 }}>Done</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const MappingAccountCountModal = ({ selectedRowData, onClose, onSuccess }) => {
    const listboxRef = useRef(null);
    const scrollTopRef = useRef(0);
    const { showToast } = useContext(AppContext);
    const [searchTerm, setSearchTerm] = useState('');
    const [state, setState] = useState({
        errors: {},
        list: [],
        deLinkList: [],
        reverseSign: false,
        selectedAccount: null,
        searchTerm: '',
        searchResults: [],
        selectedAccounts: [],
        isSearching: false,
        loading: true,
        showConfirm: false,
        recordToDelete: null
    });
    const [winWidth] = useWindowSize();
    const checkisMobile = winWidth < 1280;
    const [open, setOpen] = React.useState(false);

    const fetchTableData = async () => {
        setState((prev) => ({ ...prev, loading: true }));
        try {
            const res = await getMAMappingCategory_Accounts(selectedRowData?.maMappingCategoryID);
            if (res.success) {
                setState((prev) => ({
                    ...prev,
                    list: res.data.list.map((item) => ({
                        ...item,
                        isSelected: false
                    })),
                    loading: false
                }));
            }
        } catch (error) {
            showToast('Error loading account data');
            setState((prev) => ({ ...prev, loading: false }));
        }
    };

    const searchAccounts = debounce(async (searchValue) => {
        if (searchValue.length >= 4) {
            setState((prev) => ({ ...prev, isSearching: true }));
            try {
                const res = await getMAMappingCategory_SearchAccounts(searchValue);
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        searchResults: res.data.list
                    }));
                }
            } catch (error) {
                showToast('Error searching accounts');
            }
            setState((prev) => ({ ...prev, isSearching: false }));
        }
    }, 500);

    useEffect(() => {
        searchAccounts(state.searchTerm);
        return () => searchAccounts.cancel();
    }, [state.searchTerm]);

    const handleSearchChange = (_, value, reason) => {
        if (reason === 'input' || reason === 'clear') {
            setState((prev) => ({
                ...prev,
                searchTerm: value
            }));
            if (reason === 'input') {
                searchAccounts(value);
            }
        }
    };

    const handleAccountSelect = (_, newValue) => {
        const seen = new Set();
        const hasDuplicateInNewValue = newValue.some((item) => {
            if (seen.has(item.accountCode)) return true;
            seen.add(item.accountCode);
            return false;
        });

        if (hasDuplicateInNewValue) {
            return showToast('Duplicate Account Codes found in selection');
        }

        setState((prev) => ({
            ...prev,
            selectedAccounts: newValue
        }));
    };

    // const handleAccountSelect = (_, newValue) => {
    //     if (listboxRef.current) {
    //         scrollTopRef.current = listboxRef.current.scrollTop;
    //     }

    //     const seen = new Set();
    //     const hasDuplicateInNewValue = newValue.some((item) => {
    //         if (seen.has(item.accountCode)) return true;
    //         seen.add(item.accountCode);
    //         return false;
    //     });

    //     if (hasDuplicateInNewValue) {
    //         return showToast('Duplicate Account Codes found in selection');
    //     }

    //     setState((prev) => ({
    //         ...prev,
    //         selectedAccounts: newValue
    //     }));

    //     // Restore scroll after re-render
    //     setTimeout(() => {
    //         if (listboxRef.current) {
    //             listboxRef.current.scrollTop = scrollTopRef.current;
    //         }
    //     }, 0);
    // };

    const handleDeleteRecord = (maMappingCategoryAccountID) => {
        setState((prev) => ({
            ...prev,
            showConfirm: true,
            recordToDelete: maMappingCategoryAccountID
        }));
    };

    const confirmDelete = async () => {
        if (state.recordToDelete) {
            setState((prev) => ({ ...prev, loading: true }));
            try {
                const res = await postMAMappingCategory_DeleteNominalAccount(state.recordToDelete);
                if (res.success) {
                    showToast('Record deleted successfully');
                    onSuccess();
                    await fetchTableData();
                }
            } catch (error) {
                showToast('Error deleting record');
            } finally {
                setState((prev) => ({
                    ...prev,
                    loading: false,
                    showConfirm: false,
                    recordToDelete: null
                }));
            }
        }
    };

    const closeConfirmationModal = () => {
        setState((prev) => ({
            ...prev,
            showConfirm: false,
            recordToDelete: null
        }));
    };

    useEffect(() => {
        fetchTableData();
    }, [selectedRowData?.maMappingCategoryID]);

    const handleAddAccount = async () => {
        const data = {
            MAMappingCategoryID: selectedRowData?.maMappingCategoryID,
            AccountCode: Array.from(new Set(state.selectedAccounts.map((k) => k.accountCode))),
            ReverseSign: state.reverseSign
        };

        const res = await postMAMappingCategory_AddNominalAccount(data);
        if (res.success) {
            showToast('Account added successfully');
            onSuccess();
            await fetchTableData();
            setState((prev) => ({
                ...prev,
                searchTerm: '',
                selectedAccounts: [],
                selectedAccount: null,
                reverseSign: false
            }));
        } else {
            showToast(res.message);
        }
    };
    const handleReverseSign = async (setReverse) => {
        const res = await postMAMappingCategory_SwitchReverseSign(selectedRowData?.maMappingCategoryID, setReverse);
        if (res.success) {
            showToast(res.message || 'Reverse sign updated successfully');
            onSuccess();
            await fetchTableData();
            setState((prev) => ({
                ...prev,
                searchTerm: '',
                selectedAccount: null,
                reverseSign: false
            }));
        } else {
            showToast(res.message);
        }
    };

    useEffect(() => {
        if (state.searchResults.length > 0 && state.searchTerm) {
            setOpen(true);
        }
    }, [state.searchResults]);

    const StablePaper = React.useCallback(
        React.forwardRef((props, ref) => <CustomPaper {...props} setOpen={setOpen} ref={ref} />),
        [setOpen]
    );

    return (
        <DialogComp
            title={<TitleComponent selectedRowData={selectedRowData} handleReverseSign={handleReverseSign} />}
            onClose={() => onClose()}
            maxWidth="lg"
            fullWidth
        >
            <Grid container spacing={2} style={{ paddingBottom: 10 }}>
                {/* <Grid item xs={12}> */}
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={8} md={5} lg={6}>
                        <InputLabel>Account</InputLabel>
                        <CustomAutocomplete
                            open={open}
                            onOpen={() => {
                                if (state.searchResults.length > 0) setOpen(true);
                            }}
                            onClose={() => setOpen(false)}
                            multiple
                            freeSolo
                            options={state.searchResults}
                            getOptionLabel={(option) => (typeof option === 'object' ? `${option.accountCode} - ${option.expenseName}` : option)}
                            onInputChange={handleSearchChange}
                            onChange={handleAccountSelect}
                            value={state.selectedAccounts} // Updated for multiple selection
                            inputValue={state.searchTerm}
                            loading={state.isSearching}
                            disableCloseOnSelect
                            // PaperComponent={(paperProps) => <CustomPaper {...paperProps} setOpen={setOpen} />}
                            PaperComponent={StablePaper}
                            renderTags={(value, getTagProps) => {
                                let tempList = [];
                                let titleList = [];
                                value?.forEach((p, i) => {
                                    // if (i < 1) {
                                    // tempList.push(<Chip label={`${p.expenseName} `} {...getTagProps({ i })} />);
                                    // } else {
                                    titleList.push(
                                        <div style={{ padding: 4 }}>
                                            {p.accountCode}-{p.expenseName}
                                        </div>
                                    );
                                    // }
                                });

                                // if (value?.length > 1) {
                                tempList.push(
                                    <LightTooltip title={titleList}>
                                        <Badge color="secondary" badgeContent={value.length}>
                                            <Chip label={`Selected Codes`} />
                                        </Badge>
                                    </LightTooltip>
                                );
                                // }
                                return <div>{tempList}</div>;
                            }}
                            renderOption={(option, { selected }) => {
                                return (
                                    <div style={{}}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8, padding: '3px 10px 3px 5px' }}
                                            checked={selected}
                                        />
                                        {option.accountCode}-{option.expenseName}
                                    </div>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Account number/Account description"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: {
                                            height: '40px',
                                            // width: '550px',
                                            margin: '10px 0',
                                            paddingTop: '0'
                                        },
                                        endAdornment: (
                                            <>
                                                {state.isSearching && <CircularProgress size={20} />}
                                                {params.InputProps.endAdornment}
                                            </>
                                        )
                                    }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4} md={2} lg={2}>
                        <div style={{ marginTop: 10 }}>
                            <FormControlLabel
                                label={<span>Reverse Sign</span>}
                                control={
                                    <Checkbox
                                        checked={state.reverseSign}
                                        onChange={(e) =>
                                            setState((prev) => ({
                                                ...prev,
                                                reverseSign: e.target.checked
                                            }))
                                        }
                                        color="primary"
                                    />
                                }
                                labelPlacement="end"
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <SecondaryButton fullWidth onClick={handleAddAccount}>
                            Add
                        </SecondaryButton>
                    </Grid>
                </Grid>
                {/* </Grid> */}
                {state.loading ? (
                    <Box width="500px" height="61vh" display="flex" justifyContent="center" alignItems="center" marginLeft="500px">
                        <Grid container>
                            <CircularProgress />
                        </Grid>
                    </Box>
                ) : (
                    <TableContainer
                        style={{
                            border: '1px solid rgba(0,0,0,0.2)',
                            height: 'calc(100vh - 455px)'
                        }}
                        className="custom-scroll"
                    >
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell width={0.1}></StyledTableCell>
                                    <StyledTableCell width={200}>
                                        <span style={{ display: checkisMobile ? 'flex' : 'block', alignItems: 'center', gap: '1px' }}>Account Code</span>
                                    </StyledTableCell>
                                    <StyledTableCell width={200}>Description</StyledTableCell>
                                    <StyledTableCell width={200}>Reverse Sign</StyledTableCell>
                                    <StyledTableCell width={200}>Balance</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {state.list.map((row) => (
                                    <StyledTableRow key={row.maMappingCategoryAccountID}>
                                        <StyledTableCell>
                                            <Tooltip title="Delete Record" arrow>
                                                <DeleteOutlineIcon
                                                    onClick={() => handleDeleteRecord(row.maMappingCategoryAccountID)}
                                                    color="secondary"
                                                    style={{
                                                        cursor: 'pointer',
                                                        marginLeft: 8,
                                                        fontSize: '1.5rem'
                                                    }}
                                                />
                                            </Tooltip>
                                        </StyledTableCell>
                                        <StyledTableCell>{row.maMappingCategoryAccountCode}</StyledTableCell>
                                        <StyledTableCell>{row.expenseName}</StyledTableCell>
                                        <StyledTableCell>{row.reverseSign}</StyledTableCell>
                                        <StyledTableCell>{formatters.CurrencyThousandSeparator(row.carryForwardBalance)}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {state.showConfirm && (
                    <DialogComp title="Confirmation" onClose={closeConfirmationModal} maxWidth="md" fullWidth>
                        {state.loading ? (
                            <Grid container justifyContent="center" alignItems="center" style={{ height: '7vh' }}>
                                <CircularProgress />
                            </Grid>
                        ) : (
                            <ConfirmationModal
                                textAlign="center"
                                message="Are you sure you want to delete this record?"
                                handleSubmit={confirmDelete}
                                handleCancel={closeConfirmationModal}
                            />
                        )}
                    </DialogComp>
                )}
            </Grid>
        </DialogComp>
    );
};

export default MappingAccountCountModal;
